import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function UvLightingIcon(props) {
	return (
		<IconBase type="uv-lighting" {...props}>
			<path d="M15 2H9V3H15V2Z" />
			<path d="M9.5 3.5H11.5V19.5H9.5V3.5Z" />
			<path d="M17.3792 6.817C17.14 6.95507 17.0581 7.26086 17.1962 7.50001C17.3342 7.73916 17.64 7.82109 17.8792 7.68302L20.4773 6.18302C20.7164 6.04495 20.7983 5.73916 20.6603 5.50001C20.5222 5.26086 20.2164 5.17893 19.9773 5.317L17.3792 6.817Z" />
			<path d="M18.5 11C18.2239 11 18 11.2239 18 11.5C18 11.7761 18.2239 12 18.5 12H21.5C21.7761 12 22 11.7761 22 11.5C22 11.2239 21.7761 11 21.5 11H18.5Z" />
			<path d="M17.1962 15.5C17.3342 15.2609 17.64 15.1789 17.8792 15.317L20.4773 16.817C20.7164 16.9551 20.7983 17.2609 20.6603 17.5C20.5222 17.7391 20.2164 17.8211 19.9773 17.683L17.3792 16.183C17.14 16.0449 17.0581 15.7391 17.1962 15.5Z" />
			<path d="M5.5 11C5.77614 11 6 11.2239 6 11.5C6 11.7761 5.77614 12 5.5 12H2.5C2.22386 12 2 11.7761 2 11.5C2 11.2239 2.22386 11 2.5 11H5.5Z" />
			<path d="M6.80381 15.5C6.66574 15.2609 6.35995 15.1789 6.1208 15.317L3.52272 16.817C3.28358 16.9551 3.20164 17.2609 3.33971 17.5C3.47778 17.7391 3.78358 17.8211 4.02272 17.683L6.6208 16.183C6.85995 16.0449 6.94188 15.7391 6.80381 15.5Z" />
			<path d="M6.6208 6.817C6.85995 6.95507 6.94188 7.26086 6.80381 7.50001C6.66574 7.73916 6.35995 7.82109 6.1208 7.68302L3.52272 6.18302C3.28358 6.04495 3.20164 5.73916 3.33971 5.50001C3.47778 5.26086 3.78358 5.17893 4.02272 5.317L6.6208 6.817Z" />
			<path d="M14.5 3.5H12.5V19.5H14.5V3.5Z" />
			<path d="M7.5 20H16.5V22H7.5V20Z" />
		</IconBase>
	);
}
UvLightingIcon.propTypes = iconPropTypes;
